var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import WidgetDisplay from "@/components/widgets/widgetDisplay";
import { useAppSelector } from "@/hooks/store";
import { Slot } from "@/utils/types/layout";
import { createRef, useMemo } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
export default function DrawerEast() {
    var widgets = useAppSelector(function (state) { return state.layout.slots[Slot.DRAWER_EAST].widgets; });
    var widgetRefs = useMemo(function () { return widgets.map(function (widget) { return ({ widget: widget, nodeRef: createRef() }); }); }, [widgets]);
    return (_jsx("aside", __assign({ className: "flex-none  bg-[var(--colors-drawer-bg)]\n      mt-[var(--margin-mt-drawer-east)] mr-[var(--margin-mr-drawer-east)]\n      mb-[var(--margin-mb-drawer-east)] ml-[var(--margin-ml-drawer-east)] ".concat(widgets.length > 0
            ? "z-[999] border rounded-sm  shadow-[0_2px_20px_0px_rgba(0,0,0,0.3)]"
            : "", "  drawer-east direction-vertical scroll-contain absolute flex z-[1] h-full w-auto max-w-[75%] overflow-hidden right-0\n      ") }, { children: _jsx("div", __assign({ className: "flex-auto p-0 overflow-hidden widgets-container scroll-elements" }, { children: _jsx(TransitionGroup, __assign({ className: "widgets-list h-full overflow-auto" }, { children: widgetRefs.map(function (_a) {
                    var widget = _a.widget, nodeRef = _a.nodeRef;
                    return (_jsx(CSSTransition, __assign({ timeout: 500, nodeRef: nodeRef, classNames: "slide-left" }, { children: _jsx("div", __assign({ ref: nodeRef, className: "h-full " }, { children: _jsx("div", __assign({ className: "w-full overflow-hidden pt-0 pr-0 pb-0  widgets" }, { children: widgets.map(function (widget) { return (_jsx(WidgetDisplay, { widget: widget }, widget.id)); }) })) })) }), widget.id));
                }) })) })) })));
}
